const gridContainer = document.querySelector('.about-hero__grid');
let currentIsMobile = window.innerWidth <= 768; // Track mobile/desktop state

if (!gridContainer) {
  console.log('Grid container not found!');
} else {
  const totalAnimationDuration = 10000; // total animation time

  const imageFilenames = [
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/moerlein01.png?v=1742308216',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/ENJOY_BUILDING_-_V4.png?v=1742247204',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/products/IMG_2248.jpg?v=1681413599',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/09_Detail5.jpg?v=1745952631',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/EBTH_BizCards.jpg?v=1745946276',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/VisitLex-1.jpg?v=1745947930',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/Artboard_14_2x-100.jpg?v=1745935185',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/1_CoverImage.jpg?v=1745932996',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/FoundVillage_CaseStudy_1.jpg?v=1745938498',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/Yalls_Tickets2.jpg?v=1745875175',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/RulerFoods_1.jpg?v=1745872806',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/8_08_crown-sign2.jpg?v=1749648033',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/ASM_CaseStudy-Build_V2-24.jpg?v=1747942630',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/02_Detail1.jpg?v=1745952631',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/01_New_Full.jpg?v=1745952188',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/Workhorse_Drone_Delivery_Electric.jpg?v=1745949101',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/08_hallway_concept_space.jpg?v=1745947336',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/RRC_4.jpg?v=1745941630',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/09_TechMindedPosters.jpg?v=1745935838',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/Chips-Auto-Glass-1400.jpg?v=1745934536',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/19_SkipBillboard.jpg?v=1745932997',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/15.jpg?v=1745874614',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/9.jpg?v=1745874611',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/RulerFoods_11.jpg?v=1745872810',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/Lordstown_EnduranceBack_Electric-Truck_cd83cde0-d8d9-414e-ae8c-53c4055a0a63.jpg?v=1745871593',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/04_FLOWER.jpg?v=1745856861',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/18_LIFESTYLE.jpg?v=1745856861',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/FoundVillage_CaseStudy_4.jpg?v=1745938498',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/Artboard_12_2x-100.jpg?v=1745935184',
    'https://cdn.shopify.com/s/files/1/0034/0960/8777/files/ASM_CaseStudy-Build_V2-13.jpg?v=1747942630'
  ];

  async function populateGrid() {
    // Clear existing grid items
    gridContainer.innerHTML = '';

    const isMobile = window.innerWidth <= 768;
    currentIsMobile = isMobile;

    const columns = isMobile ? 3 : 12;
    const rows = 12;

    const imagesToCreate = isMobile ? 10 : 20;
    const staggerDelay = totalAnimationDuration / imagesToCreate;

    // Shuffle and slice to avoid duplicates
    const shuffledImages = [...imageFilenames].sort(() => 0.5 - Math.random());
    const selectedImages = shuffledImages.slice(0, imagesToCreate);

    // Initial 2s delay
    await new Promise(resolve => setTimeout(resolve, 2000));

    for (let i = 0; i < selectedImages.length; i++) {
      setTimeout(() => {
        const gridItem = document.createElement('div');
        gridItem.classList.add('about-hero__grid-item');
        gridItem.style.opacity = 0;

        const imageUrl = selectedImages[i];
        const imgElement = document.createElement('img');
        imgElement.src = imageUrl;
        imgElement.alt = 'Grid Image';
        gridItem.appendChild(imgElement);

        const row = Math.floor(Math.random() * rows) + 1;
        const col = Math.floor(Math.random() * columns) + 1;
        gridItem.style.gridRowStart = row;
        gridItem.style.gridColumnStart = col;

        gridContainer.appendChild(gridItem);

        requestAnimationFrame(() => {
          gridItem.style.transition = 'opacity 0.8s ease';
          gridItem.style.opacity = 1;
        });

        if (i === 0) {
          gridContainer.classList.add('populated');
        }
      }, i * staggerDelay);
    }
  }

  // First load
  populateGrid();

  // Listen for resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const isNowMobile = window.innerWidth <= 768;
      if (isNowMobile !== currentIsMobile) {
        populateGrid(); // Re-fire grid population only if mobile/desktop mode switched
      }
    }, 300); // Debounce
  });
}
